import { assignInlineVars } from '@vanilla-extract/dynamic';
import { Property } from 'csstype';
import * as React from 'react';

import { ComponentPropsWithoutStyles } from '@/util/ComponentPropsWithoutStyles';

import * as styles from './inputGroup.css';

export type InputGroupProps = {
  fill?: boolean;
  flex?: string;
  flexGrow?: string;
  width?: Exclude<Property.Width, 0>;
  minWidth?: Exclude<Property.MinWidth, 0>;
} & ComponentPropsWithoutStyles<React.HTMLAttributes<HTMLDivElement>>;

export const InputGroup: React.FC<InputGroupProps> = ({
  fill,
  flex,
  flexGrow,
  width,
  minWidth,
  children,
  ...props
}) => {
  if (
    fill === undefined &&
    flex === undefined &&
    flexGrow === undefined &&
    width === undefined &&
    minWidth === undefined
  ) {
    fill = true;
  }

  return (
    <div
      className={fill ? styles.root.filled : styles.root.custom}
      style={{
        ...assignInlineVars({
          [styles.flexVar]: flex ?? undefined,
          [styles.flexGrowVar]: flexGrow ?? undefined,
          [styles.widthVar]: width ?? 'unset',
          [styles.minWidthVar]: minWidth ?? 'unset',
        }),
      }}
      data-flex={flex ? '' : undefined}
      data-flex-grow={flexGrow ? '' : undefined}
      {...props}
    >
      {children}
    </div>
  );
};
